
export default function cleanName(str) {
    return str.replace(/\s+/g, '_');
  }